export default __webpack_public_path__ + "static/Bogota-activate-06f299c4905a15f286278fefcc361cd1.svg";